export interface SimulationMultiSelectDialogState {
	open: boolean;
	selectedAnalysisGroup: {
		id: string;
		label: string;
	};
	selectedSimulations: {
		id: string;
		label: string;
	}[];
}
